import { postInvite } from '../api/postInvite';

export const setPostInvite = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postInvite(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}